import React from "react";
import { LockedFeaturePage } from "../../components/LockedFeaturePage";
import { tenantCapabilityCatalogDefault, tenantCapabilityWithFallback } from "./tenantCapabilitiesRead";
import { useAuth } from "./useAuth";

export function RequireCapability(props: {
  capabilityKey?: string;
  anyOf?: string[];
  allOf?: string[];
  children: React.ReactNode;
}) {
  const auth = useAuth();
  const raw = auth.info?.capabilities;
  const enabled = (key: string) => tenantCapabilityWithFallback(raw, key, tenantCapabilityCatalogDefault(key));

  const keysToCheck = props.capabilityKey ? [props.capabilityKey] : props.allOf ?? props.anyOf ?? [];
  const anyOk = !props.anyOf || props.anyOf.length === 0 || props.anyOf.some(enabled);
  const allOk = !props.allOf || props.allOf.every(enabled);
  const singleOk = !props.capabilityKey || enabled(props.capabilityKey);
  const ok = anyOk && allOk && singleOk;

  if (!ok) {
    const lockedKey = props.capabilityKey ?? keysToCheck[0] ?? "feature";
    return <LockedFeaturePage capabilityKey={lockedKey} />;
  }

  return <>{props.children}</>;
}
